//@ts-strict-ignore
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import { getMutationProps } from './DocumentAction';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import DebitNoteDocument from '../../graphql/entities/purchases/DebitNoteDocument';
import { IJobInfo, IJobProgress } from '../../graphql/schema/p4types';

function onComplete(state: any, props: any, job: IJobInfo | IJobProgress) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Debit Note',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generate(state: any, props: any, variables: object, returnUrl: string) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    DebitNoteDocument.generate,
    getMutationProps(state, props, variables, 'supplierReturn'),
    props,
    returnUrl,
    'Generate Debit Note Document',
    (job: IJobInfo | IJobProgress) => onComplete(state, props, job)
  );
}

export function generateRange(
  state: any,
  props: any,
  variables: object,
  returnUrl: string,
  { rangeMutationProps }: { rangeMutationProps: object }
) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    DebitNoteDocument.generateRange,
    rangeMutationProps,
    props,
    returnUrl,
    'Generate Debit Note Document(s)',
    (job: IJobInfo | IJobProgress) => onComplete(state, props, job),
    (job: IJobInfo | IJobProgress) => onDocumentPrintFailed(state, props, job)
  );
}

/**
 * Reprints a set of acknowledgements (Provided as an array within variables).
 */
export function reprintRange(
  state: any,
  props: any,
  variables: object,
  returnUrl: string,
  { rangeMutationProps }: { rangeMutationProps: object }
) {
  if (hasValidationErrors(props)) return;

  createBackgroundJob(
    DebitNoteDocument.reprint,
    rangeMutationProps,
    props,
    returnUrl,
    'Generate Debit Note Document(s)',
    (job: IJobInfo | IJobProgress) => onComplete(state, props, job)
  );
}
